/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MyLearningBFFChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mylearning.bff.rpc.MyLearningBFFChirpService#getProgressItemsForMyLearningPage
 */
export const GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY_FIELD_NAME = 'com_hubspot_mylearning_bff_rpc_MyLearningBFFChirpService_getProgressItemsForMyLearningPage';
export const GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROGRESS_ITEMS_FOR_MY_LEARNING_PAGE_QUERY_FIELD_NAME,
  args: ['searchTerm', 'hasCertification', 'progressType', 'contentTypes', 'visibilityGroup', 'includePlaylistProgress', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProgressItemsForMyLearningPageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});